<template>
  <el-dialog
    :title="'挂账金额 - ' + orderInfo.policy_no"
    :visible.sync="visible"
    width="850px"
    :before-close="handleClose"
    @closed="handleClosed"
  >
    <!-- 挂账余额显示 -->
    <div class="credit-balance">
      <el-row>
        <el-col :span="12">
          <div class="balance-item">
            <span class="label">当前挂账余额：</span>
            <span class="amount">{{ formatMoney(orderInfo.credit_amount) }}元</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="balance-item">
            <span class="label">保单号：</span>
            <span class="policy-no">{{ orderInfo.policy_no }}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 挂账记录列表 -->
    <div class="amount-records">
      <h4>挂账记录</h4>
      <el-table
        :data="amountList"
        v-loading="loading"
        border
        stripe
        style="width: 100%"
        max-height="400"
      >
        <el-table-column
          prop="created_at"
          label="操作时间"
          width="160"
          :formatter="dateFormat"
        />
        <el-table-column
          prop="type"
          label="操作类型"
          width="100"
          :formatter="formatType"
        />
        <el-table-column
          prop="group_no"
          label="变更批号"
          width="120"
          :formatter="formatGroupNo"
        />
        <el-table-column
          prop="amount"
          label="金额"
          width="120"
          :formatter="formatAmountColumn"
        />
        <el-table-column
          prop="note"
          label="备注"
          show-overflow-tooltip
        />
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formatDate } from '@/utils/formatter'
import { ygbOrderAmountList } from '@/api/member'

export default {
  name: 'Buyer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      amountList: []
    }
  },
  watch: {
    visible(val) {
      console.log('Buyer组件: visible状态变化:', val, 'orderInfo:', this.orderInfo)
      if (val && this.orderInfo.id) {
        this.loadAmountList()
      }
    }
  },
  methods: {
    // 加载挂账金额列表
    async loadAmountList() {
      if (!this.orderInfo.id) {
        console.log('Buyer组件: orderInfo.id为空，无法加载数据', this.orderInfo)
        return
      }
      
      console.log('Buyer组件: 开始加载挂账记录，order_id:', this.orderInfo.id)
      this.loading = true
      try {
        const params = {
          order_id: this.orderInfo.id
        }
        console.log('Buyer组件: API请求参数:', params)
        
        const response = await ygbOrderAmountList(params)
        console.log('Buyer组件: API响应数据:', response)
        
        if (response && response.err_code === 0) {
          // 根据老项目的逻辑，过滤掉credit_amount为0的记录
          const rawData = response.rows || []
          this.amountList = rawData.filter(item => item.credit_amount != 0)
          console.log('Buyer组件: 原始数据:', rawData)
          console.log('Buyer组件: 过滤后的amountList数据:', this.amountList)
        } else {
          console.error('Buyer组件: API返回错误:', response)
          this.$message.error(response?.err_msg || '获取挂账记录失败')
        }
      } catch (error) {
        console.error('Buyer组件: 获取挂账记录失败:', error)
        this.$message.error('获取挂账记录失败')
      } finally {
        this.loading = false
      }
    },

    // 格式化金额
    formatMoney(amount) {
      if (!amount && amount !== 0) return '0.00'
      return (amount / 100).toFixed(2)
    },
    // 日期格式化
    dateFormat(row, column, cellValue) {
      return formatDate(cellValue)
    },

    // 格式化操作类型
    formatType(row, column, cellValue) {
      const typeMap = {
        1: '人工维护',
        2: '系统维护',
        4: '退保维护',
        8: '消费挂账金额',
        16: '作废订单返还'
      }
      return typeMap[cellValue] || '未知'
    },

    // 格式化变更批号
    formatGroupNo(row, column, cellValue) {
      return cellValue || '/'
    },

    // 格式化金额列
    formatAmountColumn(row, column, cellValue) {
      // 根据老项目的逻辑：如果是退保维护(type=4)，显示surrender_amount，否则显示credit_amount
      let amount = 0
      if (row.type === 4) {
        amount = row.surrender_amount || 0
      } else {
        amount = row.credit_amount || 0
      }
      
      if (!amount && amount !== 0) return '-'
      return `${this.formatMoney(amount)}元`
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
    },

    // 对话框关闭后的回调
    handleClosed() {
      this.amountList = []
    }
  }
}
</script>

<style scoped>
.credit-balance {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.balance-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.balance-item:last-child {
  margin-bottom: 0;
}

.label {
  font-weight: bold;
  color: #606266;
  margin-right: 10px;
}

.amount {
  font-size: 18px;
  font-weight: bold;
  color: #e6a23c;
}

.policy-no {
  font-size: 14px;
  color: #409eff;
}

.amount-records h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
}

.dialog-footer {
  text-align: right;
}

/* 表格中的金额颜色 */
::v-deep .el-table .cell {
  word-break: break-word;
}

/* 正数金额显示绿色 */
::v-deep .el-table tbody tr td:nth-child(3) .cell {
  color: #67c23a;
}

/* 负数金额显示红色 */
::v-deep .el-table tbody tr td:nth-child(3) .cell:contains('-') {
  color: #f56c6c;
}
</style>